import React, { Component } from 'react'
import { translate } from 'react-i18next'
import HotelBooking from '../../../public/img/GuruProfile/HotelBooking.svg'
import FlightBooking from '../../../public/img/GuruProfile/FlightBooking.svg'
import LocalSimCard from '../../../public/img/GuruProfile/LocalSimCard.svg'
import CarRental from '../../../public/img/GuruProfile/CarRental.svg'
import OnSiteMessageAssistance from '../../../public/img/GuruProfile/OnSiteMessageAssistance.svg'
import RentHouse from '../../../public/img/GuruProfile/RentHouse.svg'
import TicketsOrdering from '../../../public/img/GuruProfile/TicketsOrdering.svg'
import PublicTransport from '../../../public/img/GuruProfile/PublicTransport.svg'
import { PLANNING_SERVICES } from '../../constants'
import FontAwesome from 'react-fontawesome'

const components = {
  HotelBooking: HotelBooking,
  FlightBooking: FlightBooking,
  LocalSimCard: LocalSimCard,
  CarRental: CarRental,
  OnSiteMessageAssistance: OnSiteMessageAssistance,
  RentHouse: RentHouse,
  TicketsOrdering: TicketsOrdering,
  PublicTransport: PublicTransport
};

/*eslint no-unreachable: "off"*/
class GuruProfileServices extends Component {

  render() {
    const { serviceOffers } = this.props.user[0].plannerProfile

    const { t } = this.props

    return (
      <div className={serviceOffers.length ? 'guru-profile__services-block' : 'hidden'}>
        <h4 className="guru-profile__section-title">Service Description</h4>
        <div
          style={{
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            borderBottomColor: '#ccdfe8',
            paddingBottom: 17
          }}
        >
          {this.props.user[0] && this.props.user[0].plannerProfile && this.props.user[0].plannerProfile.serviceDescription}
        </div>

        <div className="guru-profile__feature-container">
          <h4 className="guru-profile__section-title">I provide additional services</h4>
          <div style={{ width: '100%' }}>
            {serviceOffers.map((offer, index) => {
              const icon = components[offer.service];
              return (
                <div key={index} className="guru-profile__feature">
                  <div className="row">
                    <div className="guru-profile__feature-icon">
                        <div>
                        <img src={icon} alt="" />
                      </div>
                    </div>
                    <span>{t(offer.service)}</span>
                    <span style={{ marginLeft: 25 }}>
                      {offer.price} <FontAwesome name={'usd'} />{' '}
                    </span>
                  </div>
                  <div className="row" style={{ marginTop: 12 }}>
                    <span style={{ paddingLeft: '62px' }}>{offer.description}</span>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

export default translate('booking_steps')(GuruProfileServices)




// WEBPACK FOOTER //
// src/components/Guru/GuruProfileServices.jsx